import Modal from 'ageas-react-component-modal'
import PageTitle from 'ageas-react-component-pagetitle'

import { SimulationNumberMain } from '../../GlobalStyles'
import { useSimulatorStore } from '../../Stores/simulatorStore'
import { t } from '../../i18n'
import { ModalComponent } from '../ModalComponent'
import { Documentation } from '../SimulationReport/Documentation'
import { Container } from './style'

type Props = {
  isVisible: boolean
  closeAction?: () => void
}

export const ReportSimulationModal = ({ isVisible, closeAction }: Props) => {
  const { quoteId } = useSimulatorStore()
  return (
    <ModalComponent show={isVisible}>
      <Modal
        show={isVisible}
        hideCloseAction={false}
        closeAction={closeAction}
        content={
          <Container>
            <PageTitle id="title" name={t('pages.step2.report.header')} />
            {(quoteId || '')?.length > 0 && (
              <SimulationNumberMain>
                {t('pages.step2.report.headerAlt')} {quoteId}
              </SimulationNumberMain>
            )}
            <h4>{t('pages.step2.report.subHeader')}</h4>
            <Documentation onModalClose={closeAction} />
          </Container>
        }
      />
    </ModalComponent>
  )
}
